import React from 'react';
import './termsAndConditions.style.scss';
import Footer from '../../components/footer/footer.comp';
import Navbar from '../../components/navbar/navbar.comp';

const Copyright = () => {
    return (
        <div>

            {/* Navbar */}
            <div className='section'>
                <Navbar />
            </div>

            {/* Main Section */}
            <div
                className='section text-section frame copyright'
                style={{ color: 'var(--fontlightblack1)', textAlign: 'left' }}
            >
                <h1 style={{ color: 'var(--fontlightblack1)' }}>Copyright Information</h1>

                <p>Reach provides a platform for users to discover, schedule, and participate in challenges, but we do not own the copyright to the content submitted by influencers, educators, or users. The original creators or owners retain the copyright of their content. Our role is to organize and facilitate access to these challenges.</p>

                <p>However, Reach holds copyrights and intellectual property rights on its own original works, including but not limited to:</p>

                <ul>
                    <li><strong>Platform Software:</strong> The Reach platform, including the code, design, and underlying technology, is proprietary to Reach.</li>
                    <li><strong>Logo and Branding:</strong> The Reach logo, branding, and related graphics are protected under trademark and copyright law.</li>
                    <li><strong>User Interface and Design:</strong> The design, look, and feel of the platform are copyrighted materials belonging to Reach.</li>
                    <li><strong>Platform Features:</strong> The features and functionalities of the Reach platform, including its challenge scheduling system, are protected by intellectual property rights.</li>
                </ul>

                <p>While Reach does not claim ownership of user-generated content, we retain a limited license to display, distribute, and promote this content for the purposes of platform functionality and growth, as outlined in our <a href="/terms" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>.</p>

                <p>If you believe your content has been used in a way that violates your copyright, or if you have any questions regarding copyright issues, please contact us <a href="/contact" target="_blank" rel="noopener noreferrer">here</a>.</p>
            </div>

            {/* Footer Margin */}
            <div className="footer-margin">
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default Copyright;
